import { AtomEffect, SerializableParam } from "recoil";

export const localStorageEffect: <T>(param: SerializableParam) => AtomEffect<T> =
	(param) =>
	({ setSelf, onSet }) => {
		const savedValue = localStorage.getItem(param?.toString() ?? "");
		if (savedValue != null) {
			setSelf(JSON.parse(savedValue));
		}
		onSet((newValue) => {
			localStorage.setItem(param?.toString() ?? "", JSON.stringify(newValue));
		});
	};
